export default __webpack_public_path__ + "static/media/sight-icon.31dd8033.svg";